import { number, string, shape, bool } from 'prop-types'

export default shape({
  annualizationCoefficient: number,
  days:                     number,
  isFullYear:               bool,
  isLeapYear:               bool,
  period:                   string,
  rid:                      number,
  year:                     number
})
